import { API_ERROR_CODES } from './api-error-codes';

export interface ICustomApolloError {
  graphQLErrors?: TGraphQLError[];
}

interface TGraphQLError {
  code: string;
  message: string;
}

export const apiErrorMessage = (
  error: ICustomApolloError | Error | undefined,
  options: { defaultMessage?: string; customMessage?: string } = {
    defaultMessage: 'Something wrong',
  },
) => {
  const gqlError = (error as ICustomApolloError).graphQLErrors?.[0];

  if (!gqlError && error) return (error as Error).message;
  if (!gqlError) {
    return options.defaultMessage;
  }
  if (options.customMessage) return options.customMessage;
  const code = gqlError.code;

  const errorByCode = code && API_ERROR_CODES[code];

  if (errorByCode) return errorByCode;

  if (gqlError.message) return gqlError.message;

  return options.defaultMessage;
};
